<template>
    <div class="sms-Details-box">
        <div class="smsDetails-conditions-box">
            <el-radio-group v-model="clickDate" class="smsDetails-radio-box" @change="handlerRadioChange">
                <el-radio class="smsDetails-radio-item" v-model="clickDate" size="mini" label="day">日</el-radio>
                <el-radio class="smsDetails-radio-item" v-model="clickDate" size="mini" label="week">周</el-radio>
                <el-radio class="smsDetails-radio-item" v-model="clickDate" size="mini" label="month">月</el-radio>
            </el-radio-group>
            <div class="smsDetails-pick-date">
                <el-date-picker
                        v-model="chooseTimes"
                        type="daterange"
                        align="right"
                        size="small"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="['00:00:00', '23:59:59']"
                        @change="handleDateChange">
                </el-date-picker>
            </div>
            <div>
                <span style="margin-left: 2rem;margin-right: 2rem">手机</span>
                <el-input v-model="mobile" size="small" class="inline-input" placeholder="请输入手机号" style="width: 12rem" :maxlength="11" clearable></el-input>
            </div>
            <div class="smsDetails-search-button">
                <el-button size="small" style="background-color: white; color:#00A5B2" @click="selectSmsDetails()">查询</el-button>
            </div>
        </div>
        <div class="smsDetails-number-box">
            <div class="card-a">
                <div class="card-left" style="display: inline;float: left">
                    <svg-icon icon-class="发送" style="height: 4rem;width: 5rem;display: block"></svg-icon>
                </div>
                <div class="card-right" style="display: inline-block;">
                    <div style="display: inline">
                        <span style="font-weight:bold;font-size: 2rem">{{sendNumber}}</span></div>
                    <br>
                    <div style="display:inline-block;margin-top: 0.4rem">发送条数</div>
                </div>
            </div>
            <div class="card-b">
                <div class="card-left" style="display: inline;float: left">
                    <svg-icon icon-class="失败" style="height: 4rem;width: 5rem;display: block"></svg-icon>
                </div>
                <div class="card-right" style="display: inline-block;">
                    <div style="display: inline">
                        <span style="font-weight:bold;font-size: 2rem">{{failureNumber}}</span></div>
                    <br>
                    <div style="display:inline-block;margin-top: 0.4rem">失败条数</div>
                </div>
            </div>
            <div class="card-c">
                <div class="card-left" style="display: inline;float: left">
                    <svg-icon icon-class="成功" style="height: 4rem;width: 5rem;display: block"></svg-icon>
                </div>
                <div class="card-right" style="display: inline-block;">
                    <div style="display: inline">
                        <span style="font-weight:bold;font-size: 2rem">{{successNumber}}</span></div>
                    <br>
                    <div style="display:inline-block;margin-top: 0.4rem">成功条数</div>
                </div>
            </div>
            <div class="card-d">
                <div class="card-left" style="display: inline;float: left">
                    <svg-icon icon-class="计费条数" style="height: 4rem;width: 5rem;display: block"></svg-icon>
                </div>
                <div class="card-right" style="display: inline-block;">
                    <div style="display: inline">
                        <span style="font-weight:bold;font-size: 2rem">{{billingNumber}}</span></div>
                    <br>
                    <div style="display:inline-block;margin-top: 0.4rem">计费条数</div>
                </div>
            </div>
            <div class="card-e">
                <div class="card-left" style="display: inline;float: left">
                    <svg-icon icon-class="剩余条数" style="height: 4rem;width: 5rem;display: block"></svg-icon>
                </div>
                <div class="card-right" style="display: inline-block;">
                    <div style="display: inline">
                        <span style="font-weight:bold;font-size: 2rem">{{remainingNumber}}</span></div>
                    <br>
                    <div style="display:inline-block;margin-top: 0.4rem">剩余条数</div>
                </div>
            </div>
        </div>
        <div class="div-hr"></div>
        <div class="smsDetails-table-box">
            <flex>
                <el-table class="smsDetails-table" ref="table"
                          size="small" :data="smsDetails" height="100%" width="100%"
                          :header-row-style="{color:'black'}" stripe
                          v-loading="loading"
                          @filter-change="changeConditions">
                    <el-table-column
                            type="index"
                            label="序号"
                            :index="indexMethod"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="sendTime"
                            align="center"
                            label="发送时间">
                        <template slot-scope="scope">
                            {{ formatTime(scope.row.sendTime) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="phone"
                            align="center"
                            label="手机号码">
                    </el-table-column>
                    <el-table-column
                            prop="templateType"
                            align="center"
                            label="短信类型"
                            columnKey="templateType"
                            :filters="smsTemplateTypes">
                    </el-table-column>
                    <el-table-column
                            prop="content"
                            align="center"
                            :show-overflow-tooltip="true"
                            label="短信内容">
                    </el-table-column>
                    <el-table-column
                            prop="status"
                            align="center"
                            label="发送状态"
                            columnKey="status"
                            :filters="sendStates">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status === 0">发送中</span>
                            <span v-else-if="scope.row.status === 1 || scope.row.status === 3">发送成功</span>
                            <span v-else-if="scope.row.status === 2" style="color: red">发送失败</span>
                            <span v-else>--</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="billingNum"
                            align="center"
                            label="计费条数">
                    </el-table-column>
                </el-table>
            </flex>
            <div class="smsDetails-page-box">
                <div class="page-number-box">
                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[20, 50, 100, 500, 1000]"
                            :page-size="pagesize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="dataTotal">
                    </el-pagination>
                </div>
                <div class="total-number-article">
                    截止当前累计计费&nbsp;<span
                        style="background-color: #009bac;border-radius:10%;color: white"> {{totalNumber}} </span>&nbsp;条
                </div>
            </div>
        </div>
    </div>

</template>

<script>
  import {queryRemaining, querySmsRecord} from '@/api/smsPlatform'
  import {formatToSecond, getStartAndEnd, getMonthStartDate, getMonthEndDate} from '@/utils/time'
  import {mapGetters} from 'vuex'
  import Flex from "../../../components/Flex";
  export default {
    name: "SmsDetailsManage",
    components: {Flex},
    computed: {
      ...mapGetters([
        'customerId'
      ])
    },
    data() {
      return {
        totalNumber: 0, // 累计计费条数
        sendNumber: 0, // 发送条数
        failureNumber: 0, // 失败条数
        successNumber: 0, // 成功条数
        billingNumber: 0, // 计费条数
        remainingNumber: 0, // 剩余条数
        clickDate: "month",
        chooseTimes: [getStartAndEnd('now', 'month').start, getStartAndEnd('now', 'month').end],
        mobile: "",
        smsDetails: [],
        dataTotal: 0,
        currentPage: 1,
        pagesize: 100,
        loading: false,
        smsType: [],
        smsStatus: [],
        smsTemplateTypes: [ // 短信类型
          {text: '充值', value: '充值'},
          {text: '余额', value: '余额'},
          {text: '报警', value: '报警'},
          {text: '通知', value: '通知'}
        ],
        sendStates: [ //发送状态
          {text: '发送中', value: 0},
          {text: '发送成功', value: 1},
          {text: '发送失败', value: 2}
        ],
      }
    },
    mounted() {
      this.selectRemaining()
      this.fetchData()
    },
    methods: {
      changeConditions(filters) { // 表格筛选
        // 短信类型
        if (filters.templateType !== undefined) {
          this.smsType = filters.templateType
        }
        // 发送状态
        if (filters.status !== undefined) {
          this.smsStatus = [].concat(filters.status)
          // 如选中状态为1的，则将状态为3的也选中
          if (this.smsStatus.indexOf(1) !== -1 && this.smsStatus.indexOf(3) === -1) {
            this.smsStatus.push(3)
          }
        }
        this.currentPage = 1
        this.selectRemaining()
        this.fetchData();
      },
      selectSmsDetails() {
        this.currentPage = 1
        this.selectRemaining()
        this.fetchData()
      },
      selectRemaining() { // 查询剩余条数
        const startTime = formatToSecond(this.chooseTimes[0])
        const endTime = formatToSecond(this.chooseTimes[1])
        // 查询发送条数
        queryRemaining(this.customerId, this.mobile, this.smsType, startTime, endTime).then(res => {
          if (res.code === 200) {
            this.sendNumber = res.infoJson.totalNum
            this.billingNumber = res.infoJson.billingNum
            this.failureNumber = res.infoJson.failureNum
            this.successNumber = res.infoJson.successNum
            this.remainingNumber = res.infoJson.remaining
          } else {
            this.$message({
              type: 'error',
              message: '查询发送条数失败'
            })
          }
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '查询发送条数失败'
          })
        })
        // 查询累计计费条数
        queryRemaining(this.customerId).then(res => {
          if (res.code === 200) {
            this.totalNumber = res.infoJson.billingNum
          } else {
            this.$message({
              type: 'error',
              message: '查询累计计费条数失败'
            })
          }
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '查询累计计费条数失败'
          })
        })
      },
      formatTime(time) { // 格式化时间
        if (typeof time !== 'undefined' && time !== null) {
          return formatToSecond(time)
        } else {
          return time
        }
      },
      handlerRadioChange(val) { // 时间阶段改变
        const curr = getStartAndEnd('now', val)
        this.chooseTimes = [curr.start, curr.end]
        this.currentPage = 1
        this.selectRemaining()
        this.fetchData()
      },
      fetchData() { // 查询发送记录
        this.loading = true
        const startTime = formatToSecond(this.chooseTimes[0])
        const endTime = formatToSecond(this.chooseTimes[1])
        querySmsRecord(this.currentPage, this.pagesize, this.customerId, this.mobile, null, this.smsType, startTime, endTime, this.smsStatus).then(res => {
          if (res.code === 200) {
            this.smsDetails = res.infoJson.records
            this.dataTotal = res.infoJson.total
          } else {
            this.$message({
              type: 'error',
              message: '查询短信明细失败'
            })
          }
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '查询短信明细失败'
          })
        })
      },
      handleSizeChange(size) {
        this.pagesize = size
        this.currentPage = 1
        this.fetchData()
      },
      handleCurrentChange(currentPage) {
        this.currentPage = currentPage
        this.fetchData()
      },
      handleDateChange(val) {
        this.selectRemaining()
        this.fetchData()
        this.clickDate = ""
      },
      indexMethod(index) {
        return (this.currentPage - 1) * this.pagesize + index + 1
      }
    }
  }
</script>

<style scoped rel="stylesheet/scss" lang="scss">
    .sms-Details-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        .smsDetails-conditions-box {
            width: 100%;
            font-size: 14px;
            height: 4vh;
            margin-bottom: 1%;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            .smsDetails-radio-box {
                margin-right: 20px;
                display: flex;
                .smsDetails-radio-item {
                    width: 60px;
                    height: 30px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                justify-content: center;
                align-items: center;
            }

            .smsDetails-search-button {
                margin-left: 10px;
            }
        }
        .smsDetails-number-box {
            width: 100%;
            background-color: #ffffff;
            height: 11vh;
            display: flex;
            align-items: center;
            justify-content: space-around;
            .card-a {
                margin-top: 1%;
                margin-bottom: 1%;
            }
            .card-b {
                margin-top: 1%;
                margin-bottom: 1%;
            }
            .card-c {
                margin-top: 1%;
                margin-bottom: 1%;
            }
            .card-d {
                margin-top: 1%;
                margin-bottom: 1%;
            }
            .card-e {
                margin-top: 1%;
                margin-bottom: 1%;
            }
        }

        .smsDetails-table-box {
            flex-direction: column;
            display: flex;
            width: 100%;
            height: calc(74vh - 4rem);
        }

        .smsDetails-page-box {
            height: 2rem;
            display: flex;
            margin-top: 0.2rem;
            margin-bottom: 0.2rem;
            .page-number-box {
                margin: 0 auto;
            }
            .total-number-article {
                float: right;
                text-align: right;
            }
        }

        .div-hr {
            height: 1px;
            background-color: #d1dbde;
        }
    }

    .card-right {
        padding-left: 25px;
    }


</style>
<style rel="stylesheet/scss" lang="scss">
    .el-table th {
        background-color: #f5fafb;
    }

    .sms-Details-box {

        .el-radio__inner {
            display: none;
        }
        .el-radio + .el-radio {
            margin-left: 0;
        }

        .el-radio__label {
            padding-left: 0;
        }

        label.is-checked {
            background-color: white;
            border-radius: 20px;
        }
    }

    .sms-Details-box button {
        font-weight: bold
    }

    .el-tooltip__popper {
        max-width: 20rem;
    }

</style>
